module.exports = __webpack_public_path__ + "static/media/huoban.678ce3ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/home/huoban.png
// module id = 447
// module chunks = 0